const pathname = window.location.pathname;
const scrollPos = sessionStorage.getItem("prev_scroll");

if (scrollPos) {
	const [path, pos] = JSON.parse(scrollPos);
	if (path === pathname && window.scrollY === 0) window.scrollTo(0, pos);
}

window.addEventListener("beforeunload", () => {
	const scrollPos = window.scrollY;
	sessionStorage.setItem("prev_scroll", JSON.stringify([pathname, scrollPos]));
});

/* window.addEventListener("DOMContentLoaded", function () {
	const pagination = document.querySelector("#AjaxinatePagination");

	if (!pagination) return;

	const nextButtonElement = pagination.querySelector("a");

	if (!nextButtonElement) return;

	let page = 1;

	nextButtonElement.addEventListener("click", function () {
		page++;
		window.history.pushState({ page: page }, "", `?page=${page}`);
	});
});
 */
